
<template>
    <div class="directchatemail">
        <div class="h-100">
            <div class="directchatemail__content">
                <div class="align-items-end h-100">
                    <div class="col-md text-center" v-if="isLoadingMessageEmail">
                        <b-spinner small variant="secondary"></b-spinner>
                    </div>
                <div v-else class="col-md p-0 h-100">
                    <div class="box__chatting box__chattingemail global__scrollcustom"
                        :class="isDisableChat() ? 'box__disabled' : ''"
                        v-chat-scroll="{smooth: true, notSmoothOnInit: true}"
                    >
                    <div>
                        <div :class="getBubbleRowClass(message.sender.username)"
                            v-for="(message, index) in messageEmail" :key="`${index}-A`">
                            <div :class="getBubbleColClass(message.sender.username)">
                                <div :class="getBubbleContent(message.sender.username)">
                                    <div class="bubble__icon text-center"
                                        v-if="message.sender.username !== profile.customerUsername">
                                        <p class="bubble__username"> 
                                            {{ message.sender.companyName }}  
                                            &lt;{{ message.sender.fullname ? message.sender.fullname
                                            : message.sender.username }}&gt; {{ message.sender.username === profile.customerUsername ? 'send email' : 'receive email' }}
                                        </p>
                                    </div>
                                    <div :class="getBubbleSizeClass(message.sender.username)">
                                        <p :class="message.sender.username === profile.customerUsername
                                                    ? 'time__bubble2' : 'time__bubble'">
                                            {{ getMessageDate(message.createdAt) }}
                                            <span>{{ getMessageTime(message.createdAt) }}</span>
                                        </p>
                                        <div :class="getBubbleColorClass(message.sender.username)">
                                            <div
                                            :class="message.sender.username === profile.customerUsername
                                            ? 'bubble__text2' : 'bubble__text'">
                                            <div :class="message.sender.username === profile.customerUsername
                                            ? 'bubble__headertext2' : 'bubble__headertext'">
                                            <div>
                                                <p class="mb-1"><span class="bubble__span">To:</span> <span v-for="(data, indexTo) in message.to" :key="indexTo"> {{ data }}</span></p>
                                                <p class="mb-1"><span class="bubble__span" v-if="message.cc.length !== 0">Cc:</span> <span v-for="(data, indexCc) in message.cc" :key="indexCc"> {{ data }}</span></p>
                                                <p class="mb-1"><span class="bubble__span"  v-if="message.bcc.length !== 0">Bcc:</span> <span v-for="(data, indexBcc) in message.bcc" :key="indexBcc"> {{ data }}</span></p>
                                                <p class="mb-1"><span class="bubble__span">Subject:</span> {{message.subject}}</p>
                                            </div>
                                            </div>
                                            <div v-html="message.body" class="mb-3"></div>
                                            <div v-if="message.attachment.length !== 0" class="mb-3 ml-2">
                                                <div v-for="(data, i) in message.attachment" :key="i">
                                                    <div class="d-flex flex-row mb-1 justify-content-start align-items-center"
                                                        @click.prevent="downloadDoc(message.id,
                                                        message.rfqNumber, data.type.split('/')
                                                        [ 0 ], data.type.split('/')[ 1 ],
                                                        data.fileId, message.orderNumber)">
                                            <img :class="message.sender.username === profile.customerUsername
                                                    ? 'uploadfile__icon' : 'uploadfile__icondefault'"
                                                :src="getIconFile(data.type)"
                                                title="Download File" height="28px">
                                            <div class="uploadfile pl-3">
                                                <p :class="message.sender.username === profile.customerUsername
                                                    ? 'uploadfile__desc' : 'uploadfile__desc2'">
                                                    <span style="text-underline-offset: 2px;text-decoration: underline;">{{data.type}}</span> <span class="ml-1">({{formatBytes(data.fileSize)}})</span>
                                                </p>
                                            </div>
                                            </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="bubble__icon text-center"
                                        v-if="message.sender.username === profile.customerUsername">
                                        <p class="bubble__username2">
                                            {{ message.sender.companyName }}  
                                            &lt;{{ message.sender.fullname ? message.sender.fullname
                                            : message.sender.username }}&gt; {{ message.sender.username === profile.customerUsername ? 'send email' : 'receive email' }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    </div>
                
                </div>
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { mapGetters } from 'vuex'
import * as moment from 'moment'
import * as momentTimezone from 'moment-timezone' 
import mixinFileExt from '@/mixin/getters/file-extention'
import mixinGetStatus from '@/mixin/getters/status-bid'
  
export default {
  name: 'group-chat',
  mixins: [mixinFileExt, mixinGetStatus],
  data () {
    return {
      rfqId: parseInt(this.$route.params.id_rfq, 10),
      rfqNumber: this.$route.params.rfqNumber,
      contractId: this.$route.params.id_contract,
      contractNumber: this.$route.params.contractNumber,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      isEmail: true,
      subject: ''
    }
  },
  updated () {
    this.scrollToEnd()
  },
  props: { // @override
    requestID: Number,
    requestNumber: String,
    requestType: String,
    shipmentService: String,
    referenceNumber: String,
    tabindex: Number
  },
  computed: {
    ...mapGetters({
      // get user logged profile
      profile: 'auth/profile',
      // get customer message
      messageEmail: 'chat/messageEmail',
      isLoadingMessageEmail: 'chat/isLoadingMessageEmail',
      errorMessageEmail: 'chat/errorMessageEmail',
      // get subscribers
      subscribers: 'chat/subscribers',
      isLoadingFetchSubscribers: 'chat/isLoadingFetchSubscribers',
      errorFetchSubscribers: 'chat/errorFetchSubscribers',
      // // post subscribers
      isLoadingPostSubscribers: 'chat/isLoadingPostSubscribers',
      errorPostSubscribers: 'chat/errorPostSubscribers'
      // // get rfq detail
      // custDetail: 'rfq/custDetail',
      // errorcustDetail: 'rfq/errorcustDetail',
      // isLoadingcustDetail: 'rfq/isLoadingcustDetail',
      // // // get contract detail
      // custDetailContract: 'contract/custDetail',
      // isLoadingCustDetailContract: 'contract/isLoadingCustDetail',
      // errorCustDetailContract: 'contract/errorCustDetail',
    })
  },
  mounted () {
    if (this.shipmentService === 'SHIPMENT') {
      this.fetchChannelSubscribers()
    }
    this.scrollToEnd()
  },
  methods: { 
    scrollToEnd () {
      let container = document.querySelector('.box__chattingemail')
      if (container) {
        const { scrollHeight } = container
        container.scrollTop = scrollHeight
      }
    },
    formatBytes (bytes, decimals = 2) {
      if (bytes === 0) return '0 Bytes'

      const k = 1000
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    validateEmailAddress (event) { // use shift + enter for break line, use enter for send
      if (event.keyCode === 13 && event.shiftKey === false) {
        this.sendMessages()
      }
    },
    isDisableChat () {
      if (this.custDetail) {
        return this.getStatus(this.custDetail) === 'Completed'
      }
    },
    removelinebreaks (text) {
      return text.replace(/[\r\n]+/gm, '')
    },
    getRowClass (username) {
      return username !== this.profile.customerUsername ? 'row ml-0 content__merchant' : 'row justify-content-end content__customer'
    },
    getBubbleRowClass (username) {
      return username !== this.profile.customerUsername ? 'content__merchant' : 'content__customer d-flex justify-content-end'
    },
    getBubbleColClass (username) {
      return username !== this.profile.customerUsername ? 'col-md p-0' : 'col-md p-0'
    },
    getBubbleContent (username) {
      return username !== this.profile.customerUsername ? 'content__customer row m-0 mb-5 justify-content-start' : 'content__customer row justify-content-end m-0 mb-5'
    },
    getBubbleSizeClass (username) {
      return username !== this.profile.customerUsername ? 'content__customer bubble' : 'content__customer bubble bubblemargin'
    },
    getBubbleColorClass (username) {
      return username !== this.profile.customerUsername ? 'bg__gray' : this.custDetail && this.custDetail.service_head === 'AIR' ? 'bg__purple' : 'bg__blue'
    },
    getMessageTime (date) {
      const newTime = momentTimezone(date).tz(this.timezone).format('HH:mm')
      return newTime
    },
    getMessageDate (date) {
      const newDate = momentTimezone(date).tz(this.timezone).format('DD MMM YYYY')
      const today = momentTimezone().tz(this.timezone).format('DD MMM YYYY')
      if (today === newDate) {
        return 'Today'
      } else {
        return newDate
      }
    },
    getDate (date) {
      return moment(date).format('ddd, MMM DD')
    },
    checkDate (date) {
      if (moment(this.getDate(date), 'ddd, MMM DD').isValid()) {
        const iscurrentDate = moment(date).isSame(moment(), 'day')
        const duration = moment.duration({'days': 1})
        const isyesterday = moment(duration).isBefore(moment(), 'day')
        if (iscurrentDate) {
          return 'Today'
        } else if (isyesterday) {
          return 'Yesterday'
        } else {
          return this.getDate(date)
        }
      } else {
        return 'not found'
      }
    },
    fetchChannels () {
      const token = localStorage.getItem('token')
      const shipmentId = this.rfqId || this.contractId || this.requestID
      const orderNumber = this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber ? this.contractNumber.split('-').join('/') : this.referenceNumber.split('-').join('/')
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS', { token, shipmentId, orderNumber }).then(() => {
        this.fetchMessages()
      })
    },
    fetchChannelSubscribers () {
      const shipmentId = this.requestID
      const orderNumber = this.orderNumber
      const typeMessage = 'shipment'
      this.$store.dispatch('chat/WEBSOCKET_FETCH_CHANNELS_SUBSCRIBERS', {shipmentId, orderNumber, typeMessage})
    },
    fetchMessages () {
      const shipmentId = this.rfqId || this.contractId || this.requestID
      const orderNumber = this.rfqNumber || this.contractNumber || this.referenceNumber
      const typeMessage = this.rfqId ? 'quotation' : this.contractId ? 'contract' : 'shipment'
      if (orderNumber) {
        this.$store.dispatch('chat/WEBSOCKET_FETCH_MESSAGES_EMAIL', {shipmentId, orderNumber, typeMessage})
      }
    },
    postSubscribers () {
      const typeMessage = this.rfqId ? 'quotation' : 'contract'
      const orderNumber = this.rfqNumber ? this.rfqNumber.split('-').join('/') : this.contractNumber ? this.contractNumber.split('-').join('/') : this.requestNumber.split('-').join('/')
      const payload = {
        shipmentId: this.rfqId ? parseInt(this.rfqId, 10) : parseInt(this.contractId, 10),
        orderNumber
      }
      this.$store.dispatch('chat/WEBSOCKET_POST_CHANNELS_SUBSCRIBERS', { payload, typeMessage }).then(() => {
        this.fetchChannels()
      })
    },
    downloadDoc (shipmentId, rfqNumber, fileCategory, fileExt, fileId, orderNumberr) {
      const type = this.rfqId ? 'RFQ' : this.contractId ? 'CONTRACT' : 'SHIPMENT'
      const fileName = `${rfqNumber}_${fileCategory}${fileExt}`
      const orderNumber = type === 'SHIPMENT' ? orderNumberr.split('/').join('-') : rfqNumber.split('/').join('-')
      this.$store.dispatch('shipment/DOWNLOAD_SHIPMENT_DOCUMENT', {shipmentId, orderNumber, type, fileName, fileCategory, fileId})
    }
  },
  watch: {
    tabindex (data) {
      if (data === 1) {
        this.scrollToEnd()
      }
    },
    messageEmail (data) {
      if (data) {
        this.scrollToEnd()
      }
    },
    subscribers (data) {
      if (data.length === 0) {
        this.postSubscribers()
      } else {
        this.fetchChannels()
      }
    },
    referenceNumber (data) {
      if (data) {
        if (this.subscribers.length === 0) {
          this.postSubscribers()
        } else {
          this.fetchChannels()
        }
      }
    }
  },
  sockets: {
    connect () {
      console.log('socket connected')
    },
    action (data) {
      if (data.type === 'email') {
        if (data.payload.sender.username !== this.profile.customerUsername) {
          if ((data.payload.sender.comptp === 'USER' && parseInt(data.payload.id, 10) === this.requestID) ||
                  (data.payload.sender.comptp === 'AGENT' && parseInt(data.payload.id, 10) === this.requestID) ||
                  (data.payload.sender.comptp === 'ANDALIN' && parseInt(data.payload.id, 10) === this.requestID)) {
            this.messageEmail.push(data.payload)
            this.scrollToEnd()
          }
        }
      }
      console.log('this method was fired by the socket server. eg: io.emit("action", data)')
    }
  }
}
</script> 



// WEBPACK FOOTER //
// src/components/global/GroupChatEmail.vue